// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

//Dev Environment
export const environment = {
  production: false,
  stage : {
    appurl: 'https://mediapaystage.nbcuni.com',
    //idmurl: 'http://localhost:65164/api/',  
    idmurl: 'https://mediapayuserservicestage.nbcuni.com/api/', 
   // authUrl: 'https://fss.stg.inbcu.com/fss/as/authorization.oauth2',
    MsauthUrl: 'https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4/oauth2/v2.0/authorize',

    tokenUrl :'https://fss.stg.inbcu.com/fss/as/token.oauth2',
    ///authUrl: 'https://mediapay-auth.login.sysusz.nbcuni.com/',
     MsAuthclientId: 'd48bd17d-3684-4e96-ac28-5944316c8b2c',
     MsAuthclientSecret: 'EoS8Q~fzdDWzsvXDLPPCWvSqmPZT~5lo0Edh9aU_',
    //clientId: 'Mediapaynonprod',
    //clientSecret: 'ZLWGdDWKsZ7A0k7Bw2V2Oac1wzbHkvdZFjTwhbbkj1Y4wZD59BrfkXgdDK75PJiA',
    logoutUri: 'https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4/oauth2/v2.0/logout',
    url: 'https://mediapayuserservicestage.nbcuni.com/api/',  
    Userservicebaseurl: 'https://mediapayuserservicestage.nbcuni.com', 
    Invoiceservicebaseurl: 'https://mediapayinvoiceservicestage.nbcuni.com', 
    ChangePasswordOnForgotPassword: '/ChangePasswordOnForgotPassword',
    Admin: '/Admin',
    Invoice: '/Invoice',
    RefundApprove: '/RefundApprove',
    //appurl: 'http://localhost:4200/',
     //Userservicebaseurl: 'http://localhost:65164',
    // Invoiceservicebaseurl:'http://localhost:56375',
  }
  
  // stage : {
  //   appurl: 'https://mediapaystage.nbcuni.com',  
  //   idmurl: 'https://mediapayuserservicestage.nbcuni.com/api/',
  //   authUrl: 'https://mediapay-auth.login.sysusz.nbcuni.com/',
  //   clientId: '8b0601ea-4879-4ecc-b174-d9057fbd2f45',
  //   clientSecret: 'ebbc80fb-e9af-4675-a984-0af0585cbd40',
  //   logoutUri: 'https://login.inbcu.com/ssologin/logoff.jsp?referrer=https%3A%2F%2Fmediapay-auth.login.sysusz.nbcuni.com/logout.do?redirect=',
  //   url: 'https://mediapayuserservicestage.nbcuni.com',  
  //   Userservicebaseurl: 'https://mediapayuserservicestage.nbcuni.com', 
  //   Invoiceservicebaseurl: 'https://invoiceservice-stg.prodeast1.nimbus.nbcuni.com', 
  //   ChangePasswordOnForgotPassword: '/ChangePasswordOnForgotPassword',
  //   Admin: '/Admin',
  //   Invoice: '/Invoice',
  //   RefundApprove: '/RefundApprove' 
  // }, 
  // prod : {
  //   appurl: 'https://mediapay.nbcuni.com',  
  //   idmurl: 'https://userservice-prod.prodeast1.nimbus.nbcuni.com/api/',
  //   authUrl: 'https://mediapay-auth.login.sys.nimbus-east-1.inbcu.com/',
  //   clientId: '33caa667-8158-487f-9464-be6a20f78660',
  //   clientSecret: 'ed5b1087-dccb-4c10-a2dd-088dd50a7b5f',
  //   logoutUri: 'https://login.inbcu.com/ssologin/logoff.jsp?referrer=https%3A%2F%2Fmediapay-auth.login.sys.nimbus-east-1.inbcu.com/logout.do?redirect=',
  //   url: 'https://userservice-prod.prodeast1.nimbus.nbcuni.com',  
  //   Userservicebaseurl: 'https://userservice-prod.prodeast1.nimbus.nbcuni.com', 
  //   Invoiceservicebaseurl: 'https://invoiceservice-prod.prodeast1.nimbus.nbcuni.com', 
  //   ChangePasswordOnForgotPassword: '/ChangePasswordOnForgotPassword',
  //   Admin: '/Admin',
  //   Invoice: '/Invoice',
  //   RefundApprove: '/RefundApprove'
  // }
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts